<div class="extensions-menu"
  role="menu"
  aria-orientation="vertical">
  <div *ngFor="let item of menuItems"
    class="menu-item">
    <div class="content"
      [class.selected]="item.selected"
      [class]="item.class"
      [attr.data-testid]="item.class === 'multi-extensions' ? 'nav-arc-extensions' : 'nav-' + item.class"
      [attr.title]="item.text"
      [attr.aria-label]="item.text"
      [attr.aria-current]="item.selected ? 'page' : false"
      role="menuitem"
      tabindex="0"
      (appAccessibleClick)="handleSelectItem(item)">
      <span class="text">{{item.text}}</span>
    </div>
  </div>
</div>